import React from "react";
import StaticPage from "../../components/StaticPage";

const STORIES = [
    { name: "Asha, 56", city: "Madurai", quote: "Their refill reminders saved my mother's hypertension treatment three times last year. I no longer worry about running out." },
    { name: "Dr. Vivek", city: "Bengaluru", quote: "I run a 4-bed clinic. PILLS B2B lets me order at credit-30 with a single dashboard — beats my old wholesaler entirely." },
    { name: "Sandeep, 31", city: "Pune", quote: "Subscriptions for my diabetes meds, plus the doctor consult feature, has cut my monthly trips to the pharmacy to zero." },
    { name: "Meera, 42", city: "Chennai", quote: "Lab tests at home in 24 hours and the reports were on the same app. Everything in one place is a game-changer." },
];

const Stories = () => (
    <StaticPage
        title="Health Stories"
        crumb="Stories"
        testId="page-stories"
        intro="Real voices from the PILLS community — patients, caregivers and partner clinics."
    >
        <div className="grid gap-4 md:grid-cols-2">
            {STORIES.map((s) => (
                <article key={s.name} className="rounded-2xl border border-zinc-100 bg-white p-5 dark:border-white/10 dark:bg-white/5">
                    <p className="text-sm leading-relaxed text-zinc-700 dark:text-zinc-200">"{s.quote}"</p>
                    <p className="mt-3 text-xs font-semibold uppercase tracking-wider text-brand-700">— {s.name}, {s.city}</p>
                </article>
            ))}
        </div>
    </StaticPage>
);

export default Stories;
